import { request } from "./transport";

export interface AgentReply {
  readonly content: string;
}

export interface DetectRequest {
  layers: ReadonlyArray<{
    kind: string;
    params?: Record<string, number>;
    label?: string;
  }>;
  ticker: string;
  spot: number;
  vix: number;
  dte: number;
  capital_base: number;
}

// Backtest agent payloads. Snake_case-on-the-wire would be more
// Rails-conventional, but the controller's `deep_unwrap` accepts the legacy
// camelCase keys verbatim — see Api::V1::AgentsController#backtest_compare /
// backtest_generate / backtest_plan.
export interface BacktestPlanRequest {
  regime: string | null;
  mode: string | null;
  ticker?: string;
  templateName: string;
  layers: ReadonlyArray<{ kind: string; params: Record<string, number> }>;
  config: Record<string, unknown>;
  summary: Record<string, unknown>;
  regimeStats: unknown;
  dayOfWeekStats: unknown;
  today: string;
  nextTradingDay: string;
}

export interface BacktestPlanReply {
  readonly notes: string;
  readonly tags: readonly string[];
}

export interface BacktestCompareRequest {
  layers: ReadonlyArray<{
    kind: string;
    params: Record<string, number>;
    enabled: boolean;
  }>;
  templateId: string;
  tickers: readonly string[];
  from: string;
  to: string;
  credit: number;
  creditMultiplier: number | null;
  costPerContract: number;
  vixFilter: number | null;
  stopLossPct: number | null;
  riskPct: number;
  capitalBase: number;
  slippagePerLeg: number;
  stopSlippage: number;
  profitTargetPct: number | null;
}

export interface BacktestCompareRow {
  readonly ticker: string;
  readonly summary?: Record<string, unknown>;
  readonly error?: string;
}

export interface BacktestCompareReply {
  readonly rows: readonly BacktestCompareRow[];
}

export interface BacktestGenerateRequest {
  regime: string | null;
  mode: string | null;
  ticker?: string;
  broker: string | null;
  userConfig: {
    capitalBase: number;
    costPerContract: number;
    slippagePerLeg: number;
    stopSlippage: number;
    riskPct: number;
  };
}

export interface BacktestGenerateReply {
  readonly layers?: ReadonlyArray<{
    kind: string;
    params: Record<string, number>;
  }>;
  readonly name?: string;
  readonly reasoning?: string;
  readonly from?: string;
  readonly to?: string;
  readonly riskPct?: number;
  readonly stopLossPct?: number | null;
  readonly vixFilter?: number | null;
  readonly capitalBase?: number;
  readonly costPerContract?: number;
  readonly slippagePerLeg?: number;
  readonly stopSlippage?: number;
}

export const agents = {
  detectStructure: (req: DetectRequest) =>
    request<AgentReply>("/agents/detect", {
      method: "POST",
      body: JSON.stringify(req),
    }),
  backtestPlan: (req: BacktestPlanRequest) =>
    request<BacktestPlanReply>("/agents/backtest_plan", {
      method: "POST",
      body: JSON.stringify(req),
    }),
  backtestCompare: (req: BacktestCompareRequest) =>
    request<BacktestCompareReply>("/agents/backtest_compare", {
      method: "POST",
      body: JSON.stringify(req),
    }),
  backtestGenerate: (req: BacktestGenerateRequest) =>
    request<BacktestGenerateReply>("/agents/backtest_generate", {
      method: "POST",
      body: JSON.stringify(req),
    }),
};
